// Regras de densidade do cabeçalho do ticket.
//
// Vive em arquivo próprio porque TicketHeader e TicketHeaderSkeleton precisam
// exatamente das mesmas medidas: se as duas versões divergirem, o cabeçalho
// muda de altura no momento em que o ticket termina de carregar.
//
// São seletores descendentes porque TicketInfo/TicketHeaderSkeleton montam um
// <CardHeader> do MUI sem classes próprias. Com avatar, o CardHeader usa
// variant="body2" (lh 1.43 ~= 20px) no título E no subtítulo, e o root tem
// padding 16 — o que dava os 73px originais, contra os ~47px atuais.

// O nome do contato só ganha reticências quando os pais deixam de ter
// min-width:auto.
//
// titleTypographyProps={{noWrap:true}} aplica white-space:nowrap, então a
// largura intrínseca do nome INTEIRO vira o piso da linha. O CardHeader é um
// flex item com min-width:auto (padrão) e o .MuiCardHeader-content do MUI é
// flex:1 1 auto SEM min-width (CardHeader.js:26-58) — resultado: o CardHeader
// se recusa a encolher, a linha estoura e o overflow:hidden do mainWrapper
// (Ticket/index.js) corta os botões de ação à direita.
//
// De propósito NÃO tem flex-grow: o CardHeader já é o único item que encolhe
// na linha (voltar e barra de ações são flex:none), então min-width:0 sozinho
// resolve. Com flex-grow o vão vazio entre o nome e os botões viraria área
// clicável do CardHeader, que tem onClick e abre a gaveta de contato.
const CARD_HEADER_SHRINKABLE = { minWidth: 0 };

export const ellipsisTicketHeader = () => ({
  "& .MuiCardHeader-root": { ...CARD_HEADER_SHRINKABLE },
  "& .MuiCardHeader-content": { minWidth: 0 },
});

export const compactTicketHeader = () => ({
  ...ellipsisTicketHeader(),
  // CUIDADO: este seletor também existe em ellipsisTicketHeader(), e spread de
  // objeto SUBSTITUI a chave inteira em vez de mesclar. Por isso o
  // CARD_HEADER_SHRINKABLE é repetido aqui — sem ele, o padding abaixo
  // apagaria o min-width e o bug dos botões cortados voltaria.
  "& .MuiCardHeader-root": {
    ...CARD_HEADER_SHRINKABLE,
    padding: "6px 12px",
  },
  "& .MuiCardHeader-avatar": {
    marginRight: 12,
  },
  // 32px em vez de 40px: sem isto o avatar vira o piso da altura e o ganho
  // das entrelinhas abaixo não aparece.
  "& .MuiCardHeader-avatar .MuiAvatar-root": {
    width: 32,
    height: 32,
    fontSize: "1rem",
  },
  "& .MuiCardHeader-title": {
    lineHeight: 1.25,
  },
  "& .MuiCardHeader-subheader": {
    lineHeight: 1.25,
  },
  // Linha opcional do cliente ("NOMEFANTASIA - NOMECLI"), que só aparece em
  // parte dos contatos e é a que mais engorda o cabeçalho quando existe.
  "& .MuiCardHeader-subheader .MuiTypography-caption": {
    lineHeight: 1.3,
  },
});
